import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { loadLastSearch, saveLastSearch } from "./booking";
import { toISO } from "./format";

const SearchContext = createContext(null);

function initial() {
  const s = loadLastSearch();
  const today = toISO(new Date());
  if (s && s.ci && s.ci >= today) return { adults: 2, children: 0, dog: false, ...s };
  return { ci: "", co: "", adults: s?.adults || 2, children: s?.children || 0, dog: !!s?.dog };
}

export function SearchProvider({ children }) {
  const [search, setSearchState] = useState(initial);
  const setSearch = useCallback((patch) => {
    setSearchState((prev) => ({ ...prev, ...(typeof patch === "function" ? patch(prev) : patch) }));
  }, []);
  useEffect(() => { saveLastSearch(search); }, [search]);
  const value = useMemo(() => ({ search, setSearch }), [search, setSearch]);
  return <SearchContext.Provider value={value}>{children}</SearchContext.Provider>;
}

export const useSearch = () => useContext(SearchContext);
